module.exports = __webpack_public_path__ + "img/video.26efa222.jpg";